module.exports = __webpack_public_path__ + "d47b2ab1fd83c0c14882c6012ebd8e48.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/img-morningstar.png
// module id = 1551
// module chunks = 0